import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 20px;\n  text-align: center;\n\n  svg {\n    width: 35px;\n    height: 35px;\n    margin-bottom: 10px;\n  }\n\n  p {\n    font-size: 18px;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 20px;\n  text-align: center;\n\n  svg {\n    width: 35px;\n    height: 35px;\n    margin-bottom: 10px;\n  }\n\n  p {\n    font-size: 18px;\n  }\n']);

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from '../Modal/Modal';

import { IconError } from '../Icons';

var StyledFlexWrapper = styled.div(_templateObject);

var _ref2 = React.createElement(IconError, null);

var _ref3 = React.createElement(
  'p',
  null,
  'Sorry for the inconvenience, please review your selections and choose a replacement product.'
);

var VisualizerModal = function VisualizerModal(_ref) {
  var discontinuedProductCount = _ref.discontinuedProductCount,
      closeModalFunc = _ref.closeModalFunc;

  var title = discontinuedProductCount > 1 ? discontinuedProductCount + ' items have been discontinued and are no longer available.' : discontinuedProductCount + ' item has been discontinued and is no longer available.';
  return React.createElement(
    Modal,
    {
      active: discontinuedProductCount > 0,
      closeModalFunc: closeModalFunc
    },
    React.createElement(
      StyledFlexWrapper,
      null,
      _ref2,
      React.createElement(
        'h4',
        null,
        title
      ),
      _ref3
    )
  );
};

VisualizerModal.propTypes = {
  discontinuedProductCount: PropTypes.number.isRequired,
  closeModalFunc: PropTypes.func.isRequired
};

export default VisualizerModal;